<div class="layout-wrapper">
  <div class="layout-wrapper-inner vh-100 overflow-hidden">
    <div class="layout-header px-3 py-2 d-flex justify-content-between align-items-center position-relative">
      <div class="d-flex align-items-center">
        <img src="assets/images/icons/hamburger-menu.svg" alt="" class="d-xxl-none me-4"
          (click)="openNavMenu()" style=" filter: brightness(10.5);">
          <img src="assets/images/icons/FM-logo.svg" alt="" class="me-4" (click)="openNavMenu()">

          <div class="btn-group me-2 mxw-150" dropdown>
            <div id="button-basic" dropdownToggle style="cursor: pointer;" class="d-flex flex-column align-item-center justify-content-center">
              <p class="text-white fs-16 fw-600 m-0">
                Timezone <span class="p-0 pt-0 radius-4 bg-danger fs-12 ms-1">{{selectedTimezone && selectedTimezone['offset']}}</span>
              </p>
              <p class="text-white fs-16 fw-600 m-0">
                <span class="p-0 fs-12 fs-sm-12">{{currentTime ? (currentTime | date : "MMM dd, yyyy, hh:mm:ss a" : $safeNavigationMigration(selectedTimezone?.val)) : ''}}</span>
              </p>
            </div>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
              @for (timezone of timezoneList; track timezone) {
                <li class="px-1" role="menuitem" class="cursor">
                  <a (click)="changeTimezone(timezone)" class="dropdown-item">{{timezone.offset}}-{{timezone.name}}<br /><span class="fs-14">{{currentTime | date : "MMM dd, yyyy, hh:mm:ss a" : timezone.val.toString()}}</span></a>
                </li>
              }
            </ul>
          </div>

          <!-- <div class="btn-group" dropdown> -->
          <!-- <p id="button-basic" dropdownToggle class="text-white fs-16 fw-600 m-0" style="cursor: pointer;">
          Country <span class="p-1 pt-0 radius-4 bg-danger fs-12 ms-1">{{selectedCountry && selectedCountry['country_name']}}</span>
        </p> -->
        <!-- <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
        <li *ngFor="let country of countryList" role="menuitem">
          <a (click)="changeCountry(country)" class="dropdown-item">{{country.country_name}}</a>
        </li>
      </ul> -->
    <!-- </div> -->
  </div>
  @if (latestTask && remainingMs > 0) {
    <div class="timer-popup d-flex align-items-center radius-12 me-2 cursor"  [routerLink]="['/app/sales/my-leads-details']" [queryParams]="{ lead_id: latestTask.lead_id, admin_id: isTeamLead ? latestTask.assigned_to : null }">
      <img src="/assets/images/icons/white-clock.png" class="me-2" alt="">
      <p class="fs-12 fs-sm-14 fw-500 text-white m-0">Upcoming {{this.latestTask.type ? 'Demo' : 'Follow up'}}
        with {{latestTask?.first_name}} in
      {{taskCountdown}}</p>
      <img src="/assets/images/icons/white-arrow.png" class="ms-2" alt="">
    </div>
  }
  <div class="d-flex align-items-center">
    @if (isSalesRoute && !router.url.includes('/app/sales/task-queue') && !router.url.includes('/app/sales/my-leads-details') && !router.url.includes('/app/sales/manage-teams')) {
      <app-sales-header class="me-2"></app-sales-header>
    }
    @if (isSalesRoute) {
      <div class="d-flex align-items-center contact gap-2">
        <!-- Microphone Status Pill -->
        <div class="device-status-pill audio" [class.connected]="hasMicrophone" [class.disconnected]="!hasMicrophone" (click)="toggleDevicePanel()" title="Microphone">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
            <line x1="12" x2="12" y1="19" y2="22"/>
          </svg>
          <!-- <span class="pill-label">{{ hasMicrophone ? 'Mic' : 'No Mic' }}</span> -->
          <span class="status-dot"></span>
        </div>
        <!-- Headphone / Audio Output Status Pill -->
        <div class="device-status-pill audio" [class.connected]="hasAudioOutput" [class.disconnected]="!hasAudioOutput" (click)="toggleDevicePanel()" title="Audio Output">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>
          </svg>
          <!-- <span class="pill-label">{{ hasAudioOutput ? 'Audio' : 'No Audio' }}</span> -->
          <span class="status-dot"></span>
        </div>
        <!-- Permission Warning Icon (if mic denied) -->
        @if (micPermission === 'denied') {
          <div class="device-status-pill permission-warning" (click)="showPermissionBanner = true" title="Microphone Permission Denied">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
              <line x1="12" x2="12" y1="9" y2="13"/>
              <line x1="12" x2="12.01" y1="17" y2="17"/>
            </svg>
          </div>
        }
      </div>
    }

    <div class="d-flex align-items-center me-0" >
      <a href="https://wb.denefits.com/call_stats/" target="_blank" rel="noopener noreferrer"
        class="wallboard-btn text-nowrap fs-14 fw-600 d-flex align-items-center ms-2">
        View Wallboard
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="ms-2">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
          <polyline points="15 3 21 3 21 9"/>
          <line x1="10" y1="14" x2="21" y2="3"/>
        </svg>
      </a>
      <div class="position-relative me-2" >
        <img src="assets/images/icons/bell-icon.png" width="30" class="mx-2" (click)="toggleDrawer()" style="background-color: #FFFFFF; border-radius: 20px!important; cursor: pointer;" />
        @if (notification_count > 0) {
          <span
            class="position-absolute bg-danger text-white rounded-circle fs-12 d-flex align-items-center justify-content-center text-center custom_css" [ngClass]="{ 'hw-24' :  notification_count && notification_count > 99}"
            >
            {{notification_count && notification_count > 99 ? '99+' : notification_count}}
          </span>
        }
      </div>

      @if (isSalesRoute) {
        <div class="position-relative me-0">
          <div class="me-2 ms-0 communication-toggle text-nowrap fs-14 fw-400 fs-sm-14 px-2 d-flex align-items-center"
            (click)="toggleSalesDrawer()"
            style="background-color: #FFFFFF; border-radius: 20px!important; cursor: pointer; padding: 9px 14px;" >
            Comms
            @if (communicationNotificationCount > 0) {
              <span class="badge bg-danger text-white rounded-pill ms-2 d-flex align-items-center justify-content-center"
                style="font-size: 11px; padding: 4px 6px; min-width: 18px; line-height: 1;">
                {{communicationNotificationCount > 99 ? '99+' : communicationNotificationCount}}
              </span>
            }
          </div>
        </div>
      }

      <label class="text-white fs-14 fw-600 mb-2">Live</label>
      <div class="mx-2">
        <label class="switch switch-md switch-success mt-2">
          <input type="checkbox" [checked]="isDummy" (change)="toggleChange()" />
          <span [ngClass]="!isDummy ? 'lightgreenBG' : 'bg-lightgrey' "></span>
        </label>
      </div>
      <label class="text-white fs-14 fw-600 mb-0">Dummy</label>
    </div>
    <div class="d-flex flex-row align-item-center">
      <div class="nav-item">
        <a class="nav-link cursor" (click)="searchNavBarShow = !searchNavBarShow" style="padding: 20px 0px 20px 20px;">
          <img src="assets/images/png/search.png" />
        </a>
      </div>
      <div class="btn-group" dropdown  >
        <button id="button-basic" dropdownToggle placement="bottom center" type="button"
          class="btn dropdown-toggle pe-0 text-end" aria-controls="dropdown-basic">
          <img  [src]="_shared.adminProfileImage || 'assets/images/icons/profile_placeholder.png'"  class="profile-icon rounded-circle border hw-40"
            alt="" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="fill: white;"
            class="toggle-arrow hw-20 ms-1" >
            <path
              d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
              </svg> <span class="caret"></span>
            </button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right width" role="menu"
              aria-labelledby="button-basic">
              <div class="pb-3 border-bottom">
                <p class="text-center m-0 fs-14 fw-500 text-capitalize">{{admin_profile.admin_name}}</p>
                <p class="text-center m-0 fs-14 fw-500 text-capitalize">Role: {{role}}</p>
              </div>
              <li role="menuitem" class="border-bottom py-1">
                <button class="dropdown-item py-1 fs-14 fw-500" [routerLink]="['/app/home/profile']" tappable><img src="assets/images/png/user.png" class="me-2 hw-18"
                alt="" > Profile</button>
              </li>
              <li role="menuitem" class=" d-flex align-items-center py-1">
                <button class="dropdown-item py-1 fs-14 fw-500" (click)="showLogoutModal()" tappable><img src="assets/images/png/log-out.png" class="me-2 hw-18"
                alt="" > Logout</button>
              </li>
            </ul>
          </div>


          @if ((admin_profile?.role_id ?? 0) < 16) {
            <div class="position-absolute top-0 end-0 w-100 bg-white h-100 bg-primary search-bar"  [ngClass]="{'show': searchNavBarShow}">
              <app-navsearch [visible]="searchNavBarShow" (onclose)="searchNavBarShow = false"></app-navsearch>
            </div>
          }
        </div>
      </div>
      <div class="position-absolute top-0 end-0 w-100 bg-white h-100 bg-primary search-bar"  [ngClass]="{'show': searchNavBarShow}">
        <app-navsearch [visible]="searchNavBarShow" (onclose)="searchNavBarShow = false"></app-navsearch>
      </div>
    </div>

    <!-- ─── Permission Denied Banner (sales route only) ─── -->
    @if (isSalesRoute && showPermissionBanner) {
      <div class="permission-banner">
        <div class="permission-banner-inner">
          <div class="d-flex align-items-center">
            <div class="permission-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                <line x1="12" x2="12" y1="9" y2="13"/>
                <line x1="12" x2="12.01" y1="17" y2="17"/>
              </svg>
            </div>
            <div class="ms-3 flex-fill">
              <p class="m-0 fs-14 fw-600 text-dark">Microphone permission is blocked</p>
              <p class="m-0 fs-12 text-muted">
                Microphone access is denied. Click the lock icon
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="inline-icon"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                in the address bar and set microphone to <strong>Allow</strong>, then reload.
              </p>
            </div>
            <button class="btn-dismiss ms-2" (click)="dismissPermissionBanner()">&times;</button>
          </div>
        </div>
      </div>
    }

    <!-- ─── Device Status Panel (sales route only) ─── -->
    @if (isSalesRoute && showDevicePanel) {
      <div class="device-panel-overlay" (click)="showDevicePanel = false"></div>
    }
    @if (isSalesRoute && showDevicePanel) {
      <div class="device-panel">
        <div class="device-panel-header">
          <h6 class="m-0 fw-700">Device Status</h6>
          <button class="btn-dismiss" (click)="showDevicePanel = false">&times;</button>
        </div>
        <div class="device-panel-body">
          <!-- Microphone status -->
          <div class="device-section">
            <div class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/>
                <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
                <line x1="12" x2="12" y1="19" y2="22"/>
              </svg>
              <span>Microphone</span>
              <span class="badge" [class.bg-success]="hasMicrophone" [class.bg-danger]="!hasMicrophone">{{ hasMicrophone ? 'Connected' : 'Not Found' }}</span>
            </div>
            @if (hasMicrophone) {
              <p class="device-status-text">
                <span class="device-dot connected"></span> {{ micDeviceName }}
              </p>
            }
            @if (!hasMicrophone) {
              <p class="device-status-text text-danger">
                <span class="device-dot disconnected"></span> No microphone detected. Please connect one to make calls.
              </p>
            }
          </div>
          <!-- Speaker / Headphone status -->
          <div class="device-section">
            <div class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"/>
              </svg>
              <span>Speaker / Headphone</span>
              <span class="badge" [class.bg-success]="hasAudioOutput" [class.bg-danger]="!hasAudioOutput">{{ hasAudioOutput ? 'Connected' : 'Not Found' }}</span>
            </div>
            @if (hasAudioOutput) {
              <p class="device-status-text">
                <span class="device-dot connected"></span> {{ audioDeviceName }}
              </p>
            }
            @if (!hasAudioOutput) {
              <p class="device-status-text text-danger">
                <span class="device-dot disconnected"></span> No speaker or headphone detected. Please connect one.
              </p>
            }
          </div>
          <!-- Permissions -->
          <div class="device-section permissions-section">
            <div class="section-title">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <span>Permissions</span>
            </div>
            <div class="permission-row">
              <span>Microphone</span>
              <span class="perm-badge" [ngClass]="{'granted': micPermission === 'granted', 'denied': micPermission === 'denied', 'prompt': micPermission === 'prompt'}">{{ micPermission }}</span>
            </div>
            @if (micPermission !== 'granted' && !showPermissionBanner) {
              <button class="btn btn-sm btn-success w-100 mt-2" (click)="showPermissionBanner = true">Grant Microphone Access</button>
            }
          </div>
        </div>
      </div>
    }

    <div class="layout-body d-flex">
      <div class="side-menu-wrapper h-100 w-100 overflow-auto hide-scroll-bar border bg-white top-0 start-0"
        id="mySidenav">
        <img src="assets/images/icons/cross-icon.svg" alt=""
          class="close-menu text-white d-xxl-none position-absolute top-0 end-0 mt-3 me-3 hw-24"
          (click)="closeNavMenu()">
          <ul class="menu p-0 pt-3">
            @for (menu of menuList; track menu) {
              <li class="decoration-none px-3 pb-3 cursor">
                <span class="d-flex w-100 justify-content-between" (click)="toggleMenu(menu)" [ngClass]="{ 'active': menu.isOpen }">
                  <div class="d-flex align-items-center">
                    @if (menu.icon || menu.slug) {
                      <img [src]="'assets/images/sidebarIcons/' + (menu.icon || menu.slug) + '.png'" [ngClass]="menu.isOpen || menu === selectedParentMenu ? 'green-icon' : '' " alt="" style="height: 20px;margin-right: 6px;">
                    }
                    <p class="m-0 fs-14 fw-600 " [ngClass]="menu.isOpen || menu === selectedParentMenu ? 'text-success' : 'text-icon-color' ">
                      {{ menu.menu_name }}
                    </p>
                  </div>
                  @if (menu.submenu) {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 14px;"
                      class="toggle-arrow" [ngClass]="{ 'rotate': menu.isOpen }">
                      <path
                        d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" fill="rgba(33, 37, 41, 0.75)" />
                      </svg>
                    }
                  </span>
                  <ul class="sub-menu pl-1 overflow-hidden position-relative"
                    [ngClass]="{ 'active': menu.isOpen }">
                    @for (subMenu of menu.submenu; track subMenu) {
                      <li class="decoration-none p-1 fs-14 fw-600 " [ngClass]=" selectedSubMenu && selectedSubMenu.isOpen && subMenu.path == selectedSubMenu.path ? 'text-success' : 'text-muted'"
                        (click)="toggleMenu(subMenu,menu)">
                        {{ subMenu.menu_name }}
                      </li>
                    }
                  </ul>
                </li>
              }
            </ul>

          </div>
          <div class="right-content overflow-auto flex-fill">
            <router-outlet></router-outlet>
            <app-incoming-call></app-incoming-call>
          </div>
          <app-active-call-widget></app-active-call-widget>
        </div>
      </div>
    </div>

    @if (isSalesDrawerOpen) {
      <div class="sales-drawer-container">
        <div class="drawer-overlay" (click)="toggleSalesDrawer()"></div>
        <div class="sales-drawer-content drawer-content-communication d-flex flex-column"
          [@salesDrawerState]="isSalesDrawerOpen ? 'open' : 'closed'">
          <div>
            <div class="drawer-header comm-center-header d-flex justify-content-between align-items-start mb-3">
              <div class="comm-center-heading pe-3">
                <div class="d-flex align-items-center gap-2 flex-wrap mb-2">
                  <h5 class="m-0 fw-700 text-dark">Communication Center</h5>
                  <span class="comm-center-live-pill">Live Feed</span>
                </div>
                <p class="comm-center-subtitle mb-0">Review recent emails, messages, and calls from one place.</p>
              </div>
              <img src="assets/images/icons/cross-icon.svg" class="close-btn-alt comm-close-btn hw-30 p-1 border rounded-circle cursor" alt=""
                (click)="toggleSalesDrawer()">
              </div>
              <div class="sales-tabs-wrapper mb-4">
                <div class="sales-tabs d-flex">
                  <button type="button" class="sales-tab flex-fill d-flex align-items-center justify-content-center cursor" [class.active]="salesActiveTab === 'emails'" (click)="setSalesActiveTab('emails')">
                    <img src="assets/images/icons/mail.png" class="tab-icon me-2" width="20" alt="">
                    <div class="d-flex align-items-center position-relative">
                      <span class="fs-12 fw-600 tab-label">Emails</span>
                      @if (emailNotificationCount > 0) {
                        <span class="badge tab-count-badge bg-danger rounded-pill ms-2 text-white d-flex align-items-center justify-content-center"
                          >
                          {{emailNotificationCount > 99 ? '99+' : emailNotificationCount}}
                        </span>
                      }
                    </div>
                  </button>
                  <button type="button" class="sales-tab flex-fill d-flex align-items-center justify-content-center cursor" [class.active]="salesActiveTab === 'messages'" (click)="setSalesActiveTab('messages')">
                    <img src="assets/images/icons/message.png" class="tab-icon me-2" width="20" alt="">
                    <div class="d-flex align-items-center position-relative">
                      <span class="fs-12 fw-600 tab-label">Messages</span>
                      @if (smsNotificationCount > 0) {
                        <span class="badge tab-count-badge bg-danger rounded-pill ms-2 text-white d-flex align-items-center justify-content-center"
                          >
                          {{smsNotificationCount > 99 ? '99+' : smsNotificationCount}}
                        </span>
                      }
                    </div>
                  </button>
                  <button type="button" class="sales-tab flex-fill d-flex align-items-center justify-content-center cursor" [class.active]="salesActiveTab === 'calls'" (click)="setSalesActiveTab('calls')">
                    <img src="assets/images/icons/call-icon.png" class="tab-icon me-2" width="20" alt="">
                    <div class="d-flex align-items-center position-relative">
                      <span class="fs-12 fw-600 tab-label">Calls</span>
                      @if (callNotificationCount > 0) {
                        <span class="badge tab-count-badge bg-danger rounded-pill ms-2 text-white d-flex align-items-center justify-content-center"
                          >
                          {{callNotificationCount > 99 ? '99+' : callNotificationCount}}
                        </span>
                      }
                    </div>
                  </button>
                </div>
              </div>
              <!-- Mapped/Unmapped Filter Chips -->
              <div class="chip-filter-container mb-2">
                <div class="chip-filter-header d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <div class="d-flex gap-3 align-items-center">
                      <button type="button" class="chip-filter cursor" [class.active]="commCenterMappedFilter === 'all'"
                        (click)="setMappedFilter('all')">
                        <span class="chip-label">All</span>
                        @if (commCenterMappedFilter === 'all') {
                          <span class="chip-indicator"></span>
                        }
                      </button>
                      <button type="button" class="chip-filter cursor" [class.active]="commCenterMappedFilter === 'mapped'"
                        (click)="setMappedFilter('mapped')">
                        <span class="chip-label">Mapped</span>
                        @if ((salesActiveTab === 'emails' && mappedEmailNotificationCount > 0) ||
                          (salesActiveTab === 'messages' && mappedSmsNotificationCount > 0) ||
                          (salesActiveTab === 'calls' && mappedCallNotificationCount > 0)) {
                          <span class="badge bg-danger text-white rounded-pill ms-2 d-flex align-items-center justify-content-center"
                            style="font-size: 10px; padding: 2px 6px; min-width: 16px; line-height: 1;">
                            {{salesActiveTab === 'emails' ? (mappedEmailNotificationCount > 99 ? '99+' : mappedEmailNotificationCount) :
                            salesActiveTab === 'messages' ? (mappedSmsNotificationCount > 99 ? '99+' : mappedSmsNotificationCount) :
                            (mappedCallNotificationCount > 99 ? '99+' : mappedCallNotificationCount)}}
                          </span>
                        }
                        @if (commCenterMappedFilter === 'mapped') {
                          <span class="chip-indicator"></span>
                        }
                      </button>
                      <button type="button" class="chip-filter cursor" [class.active]="commCenterMappedFilter === 'unmapped'"
                        (click)="setMappedFilter('unmapped')">
                        <span class="chip-label">Unmapped</span>
                        @if ((salesActiveTab === 'emails' && unmappedEmailNotificationCount > 0) ||
                          (salesActiveTab === 'messages' && unmappedSmsNotificationCount > 0) ||
                          (salesActiveTab === 'calls' && unmappedCallNotificationCount > 0)) {
                          <span class="badge bg-danger text-white rounded-pill ms-2 d-flex align-items-center justify-content-center"
                            style="font-size: 10px; padding: 2px 6px; min-width: 16px; line-height: 1;">
                            {{salesActiveTab === 'emails' ? (unmappedEmailNotificationCount > 99 ? '99+' : unmappedEmailNotificationCount) :
                            salesActiveTab === 'messages' ? (unmappedSmsNotificationCount > 99 ? '99+' : unmappedSmsNotificationCount) :
                            (unmappedCallNotificationCount > 99 ? '99+' : unmappedCallNotificationCount)}}
                          </span>
                        }
                        @if (commCenterMappedFilter === 'unmapped') {
                          <span class="chip-indicator"></span>
                        }
                      </button>
                    </div>
                  </div>
                  <span class="results-count-pill">{{ filteredCommunicationLogs.length || 0 }} items</span>
                </div>
              </div>
            </div>
            <div class="tab-content-area comm-scroll-area flex-fill overflow-auto d-flex flex-column px-1 py-1">
              @if (isLoading) {
                <div class="d-flex justify-content-center py-5">
                  <div class="spinner-border text-success" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              }
              <!-- Content wrapper with basic list animation -->
              @if (filteredCommunicationLogs; as logs) {
                @if (logs.length === 0) {
                  <div class="empty-state text-center py-5 fade-in">
                    <div class="empty-state-card mx-auto">
                      <div class="empty-state-icon mx-auto mb-3 d-flex align-items-center justify-content-center">
                        <img [src]="'assets/images/icons/' + (salesActiveTab === 'calls' ? 'call-icon' : salesActiveTab === 'messages' ? 'message' : 'mail') + '.png'" class="opacity-50" width="28" alt="">
                      </div>
                      <p class="empty-state-kicker mb-2">Nothing queued right now</p>
                      <h6 class="empty-state-title mb-2">No {{salesActiveTab}} found for your recent interactions.</h6>
                      <p class="empty-state-copy mb-0">New communication threads will appear here as they come in.</p>
                    </div>
                  </div>
                }
                <!-- Communication Log Cards -->
                @for (item of logs; track item; let i = $index) {
                  <div class="comm-log-card p-3 mb-3 bg-white cursor slide-up-animation"
                    [ngClass]="{'is-unmapped': !item.lead_id, 'is-grouped': item.logs_count > 1}"
                    [style.animation-delay.ms]="i * 50" (click)="redirectToLead(item)">
                    <div class="d-flex align-items-start">
                      <div class="icon-wrapper comm-log-icon d-flex align-items-center justify-content-center radius-8 p-2 me-3 flex-shrink-0"
                        [ngClass]="{'bg-primary-light': salesActiveTab === 'emails', 'bg-success-light': salesActiveTab === 'messages', 'bg-warning-light': salesActiveTab === 'calls'}">
                        <img [src]="'assets/images/icons/' + (salesActiveTab === 'calls' ? 'call-icon' : salesActiveTab === 'messages' ? 'message' : 'mail') + '.png'" width="18" alt="" [style.filter]="salesActiveTab === 'messages' ? 'brightness(0) saturate(100%) invert(43%) sepia(50%) saturate(632%) hue-rotate(85deg) brightness(85%) contrast(85%)' : ''">
                      </div>
                      <div class="d-flex flex-column flex-grow-1 w-100 comm-log-content">
                        <div class="d-flex justify-content-between align-items-start w-100 mb-2 comm-log-top flex-wrap gap-2">
                          <div class="d-flex flex-column pe-2 overflow-hidden w-100">
                            <div class="d-flex justify-content-between">
                              <h6 class="m-0 fs-16 fw-700 text-dark header-text d-flex align-items-center flex-wrap gap-2 mb-1">
                                <span class="text-truncate max-w-100">
                                  @if (item.first_name || item.last_name) {
                                    {{salesActiveTab === 'emails' ? item.from_email || item.to_email : item.from_number || item.to_number}}
                                  } @else {
                                    {{item.from_number || item.to_number || item.from_email || item.to_email || item.contact || 'Unknown Contact'}}
                                  }
                                </span>
                                @if (item.logs_count > 1) {
                                  <span
                                    class="badge radius-6 px-2 py-1 fs-11 text-slate-500 bg-slate-100 border flex-shrink-0" style="font-weight: 600;">
                                    {{item.logs_count}} {{salesActiveTab === 'emails' ? 'Emails' : salesActiveTab === 'messages' ? 'Messages' :
                                    'Calls'}}
                                  </span>
                                }
                              </h6>
                              @if (salesActiveTab === 'calls') {
                                <div
                                  class="badge call-status-badge radius-6 fw-600 px-2 py-1 fs-11 text-uppercase letter-spacing-1 flex-shrink-0"
                                  [ngClass]="getCallStatusClass(item)">
                                  {{ getCallStatusLabel(item) }}
                                </div>
                              }
                            </div>
                            <div class="card-meta-row d-flex flex-wrap align-items-center gap-2 mb-2">
                              <span class="thread-state-pill" [ngClass]="item.lead_id ? 'is-mapped' : 'is-unmapped'">
                                {{ item.lead_id ? 'Mapped Lead' : 'Unmapped Thread' }}
                              </span>
                              <!-- <span class="channel-hint">
                              {{ salesActiveTab === 'emails' ? 'Email thread' : salesActiveTab === 'messages' ? 'Message thread' : 'Call thread' }}
                            </span> -->
                          </div>
                          @if (item.all_lead_ids_array && item.all_lead_ids_array.length > 0) {
                            <div class="d-flex flex-wrap gap-1 mt-1">
                              @for (lead of item.all_lead_ids_array; track lead) {
                                <span
                                  class="badge lead-chip bg-slate-50 text-slate-600 border px-2 py-1 radius-4 fs-11 cursor transition hover-bg-slate-200"
                                  style="font-weight: 500;"
                                  (click)="redirectToSpecificLead(lead, $event)">
                                  Lead: {{lead.lead_id}}
                                </span>
                              }
                            </div>
                          }
                        </div>
                        <div class="d-flex gap-2 flex-shrink-0 mt-1">
                          <!-- <span class="badge radius-6 fw-600 px-2 py-1 fs-11 text-uppercase letter-spacing-1"
                          [ngClass]="(item.direction && (item.direction !== 'INBOUND' && item.direction !== 'inbound')) ? 'bg-primary-light text-primary' : 'bg-success-light text-success'">
                          {{ item.direction || 'INBOUND' }}
                        </span> -->
                        <!-- Status Tag for Calls -->
                        <!-- <button type="button" class="lead-arrow-btn flex-shrink-0"
                        *ngIf="item.lead_id && salesActiveTab === 'calls'"
                        (click)="redirectToSpecificLead(item, $event)"
                        aria-label="Redirecting to lead"
                        title="Redirecting to lead">
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                      </button> -->
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-wrap log-timestamp">
                    <span class="fs-12 text-slate-500 fw-500">{{(item.created || item.created_at) | date:'MMM dd, yyyy, hh:mm a'}}</span>
                    <span class="mx-1 text-slate-300">|</span>
                    <span class="fs-12 fw-600 text-slate-400">{{getTimeAgo(item.created || item.created_at)}}</span>
                  </div>
                </div>
              </div>
              @if (getCommunicationContent(item) || salesActiveTab === 'calls' || (item.lead_id && salesActiveTab !== 'calls' && getGroupedLogs(item).length > 0) || (!item.lead_id && getAttachments(item).length > 0)) {
                <div class="log-body"
                 [ngClass]="{
                   'mt-2 pt-2 border-top has-mapped-group-list': item.lead_id && salesActiveTab !== 'calls',
                   'mt-1 pt-2 border-top': !item.lead_id || salesActiveTab === 'calls'
                 }">
                  @if (item.lead_id && salesActiveTab !== 'calls') {
                    <div class="mapped-group-list" (click)="$event.stopPropagation()">
                      @for (groupedItem of getGroupedLogs(item); track groupedItem) {
                        <div
                          class="mapped-group-row d-flex align-items-center justify-content-between gap-3">
                          <div class="mapped-group-copy min-w-0">
                            <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                              <span class="mapped-group-lead-pill">Lead {{groupedItem.lead_id}}</span>
                            </div>
                            <div class="mapped-group-time d-flex align-items-center flex-wrap">
                              <span>{{(groupedItem.created || groupedItem.created_at) | date:'MMM dd, yyyy'}}</span>
                              <span class="mapped-group-divider">|</span>
                              <span>{{(groupedItem.created || groupedItem.created_at) | date:'hh:mm a'}}</span>
                            </div>
                          </div>
                          <div class="mapped-group-actions d-flex align-items-center gap-2 flex-shrink-0">
                            @if (getCommunicationContent(groupedItem)) {
                              <button type="button"
                                class="btn btn-outline-primary btn-sm btn-view-content fs-12 fw-600 radius-6 px-3 py-1"
                                (click)="openCommunicationContentModal(unmappedContentModal, groupedItem, $event)">
                                View Full Content
                              </button>
                            }
                            <button type="button"
                              class="lead-arrow-btn"
                              (click)="redirectToSpecificLead(groupedItem, $event)"
                              aria-label="Redirecting to lead"
                              title="Redirecting to lead">
                              <i class="fa fa-chevron-right" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (getCommunicationContent(item) && !item.lead_id) {
                    <p class="m-0 fs-14 text-slate-600 text-truncate-3 message-text">
                      {{getCommunicationContent(item)}}
                    </p>
                  }
                  @if (!item.lead_id && (salesActiveTab === 'emails' || salesActiveTab === 'messages')) {
                    <div class="mt-2">
                      <button type="button" class="btn btn-outline-primary btn-sm btn-view-content fs-12 fw-600 radius-6 px-3 py-1"
                        (click)="openCommunicationContentModal(unmappedContentModal, item, $event)">
                        View Full Content
                      </button>
                    </div>
                  }
                  @if (salesActiveTab === 'calls') {
                    <div class="d-flex align-items-center mt-2">
                      <!-- <div class="duration-badge d-inline-flex align-items-center bg-slate-100 radius-6 px-2 py-1">
                      Duration Icon using SVG -->
                      <!--<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width  ="2" stroke-linecap="round" stroke-linejoin="round" class="me-1 text-slate-500"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                      <span class="fs-12 fw-600 text-slate-600">{{item.duration ? item.duration + 's' : '0s'}}</span>
                    </div> -->
                  </div>
                }
                @if (!item.lead_id && getAttachments(item); as itemAttachments) {
                  @if (itemAttachments.length > 0) {
                    <div class="mt-3 d-flex flex-wrap gap-2">
                      @for (url of itemAttachments; track url; let idx = $index) {
                        <a
                          [href]="url" target="_blank"
                          (click)="$event.stopPropagation()"
                          class="attachment-chip d-inline-flex align-items-center bg-primary-light text-primary border border-primary-light px-2 py-1 fs-11 fw-600 text-decoration-none cursor radius-6 transition">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-1"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
                          Attachment {{itemAttachments.length > 1 ? (idx + 1) : ''}}
                        </a>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
}

@if (!isCollapsed) {
  <div class="drawer-container">
    @if (!isCollapsed) {
      <div class="drawer-overlay" (click)="toggleDrawer()"></div>
    }
    <div class="drawer-content" [@drawerState]="isCollapsed ? 'closed' : 'open'">
      <!-- <button class="close-btn" (click)="toggleDrawer()">✖</button> -->
      <img src="assets/images/icons/cross-icon.svg" class="close-btn hw-30 p-1 border rounded-circle cursor" alt=""(click)="toggleDrawer()">
      <p>Notifications</p>
      <div #notificationList class="list-group mt-3 notification-list" (scroll)="onNotificationScroll($event)">
        @for (notification of notifications; track notification; let i = $index) {
          <div
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            [ngClass]="{'bg-primary':(!notification.read_at || notification.read_at==null)}"
            style="cursor: pointer!important;"
            >
            <div class="d-flex flex-column" [ngClass]="{'text-white':(!notification.read_at || notification.read_at==null)}" (click)="redirectToNotification(notification, i)">
              <strong>{{ notification.title }} || {{ notification.admin_name }}</strong>
              <p class="mb-0 small">{{ notification.message }}</p>
              <p class="mb-0 small">
                {{notification.sent_at | date:'MM/dd/yyyy hh:mm a':timezone}}
                ({{timezoneName ? timezoneName: 'X'}})
              </p>
            </div>
          </div>
        }
        @if (isLoading) {
          <div class="text-center py-3">
            <p>Loading more...</p>
          </div>
        }
        @if (notifications.length === 0 && !isLoading) {
          <div class="text-center text-muted mt-3">
            <p>No new notifications</p>
          </div>
        }
      </div>
      <div class="d-flex justify-content-between mt-3 p-2 flex-shrink-0">
        @if (showNotificationViewAll()) {
          <button class="btn btn-primary btn-sm" style="margin-top: 0px;font-size: 12px;padding: 7px 0px;" (click)="viewMore()">View All</button>
        }
        <a class="mark-all-read" style="margin-top: 5px; cursor:pointer" (click)="markAllAsRead()">Mark All as Read</a>
      </div>
    </div>
  </div>
}

<!-- Communication Center Live Alerts -->
<div class="comm-alert-container">
  @for (alert of activeCommAlerts; track alert) {
    <div class="comm-alert-card slide-left-animation" (click)="toggleSalesDrawer(); removeCommAlert(alert.id)">
      <div class="alert-icon">
        <img [src]="'assets/images/icons/' + (alert.type?.toLowerCase().includes('call') || alert.type?.toLowerCase().includes('phone') || !alert.type ? 'call-icon' : alert.type?.toLowerCase().includes('sms') || alert.type?.toLowerCase().includes('message') ? 'message' : 'mail') + '.png'" class="pulse-icon" width="22" alt="">
      </div>
      <div class="alert-content">
        <div class="alert-header">
          <h6 class="alert-title">{{alert.title || alert.first_name || alert.contact || 'New Communication'}}</h6>
          <span class="alert-time">Just now</span>
        </div>
        <p class="alert-body">{{alert.message || alert.content || alert.message_body || 'You have received a new ' + (alert.type || 'message') + ' notification.'}}</p>
      </div>
      <div class="alert-close" (click)="$event.stopPropagation(); removeCommAlert(alert.id)">
        <img src="assets/images/icons/cross-icon.svg" alt="Close">
      </div>
    </div>
  }
</div>

<app-password-expiry-reminder></app-password-expiry-reminder>

<!-- <app-navsearch [visible]="searchNavBarShow" (onclose)="searchNavBarShow = false"></app-navsearch> -->
<ng-template #loginAuthentication>
  <div class="modal-content border-0">
    <div class="position-relative bg-white radius-16">
      <div class="modal-header border-0 p-3 m-0 text-center fs-20 fw-700 justify-content-center">
        Access Restricted – Confidential System
      </div>

      <div class="modal-body p-4 border-top border-bottom">
        <p class="fs-14 fw-500 grey-106 mb-1">
          You are entering <strong>FinanceMutual<sup>TM</sup> Admin Panel.</strong>
        </p>
        <p class="fs-14 fw-500 grey-106 mb-4">
          All actions within this system are monitored and logged in real-time.
        </p>
        <h4 class="fs-16 fw-700 mb-3">
          By proceeding, you agree to:
        </h4>
        <ul>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Abide by all data privacy and confidentiality policies
          </li>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Handle all information in accordance with company security standards
          </li>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Not misuse, share, or disclose any sensitive data
          </li>
        </ul>
        <button class="btn btn-primary cursor mt-3" (click)="proceedToLogin()">I Acknowledge</button>
      </div>
      <div class="modal-footer">
        <div class="d-flex align-items-start">
          <img src="assets/images/icons/danger.svg" class="me-2 hw-16 mt-1" alt="">
          <p class="fs-12 fw-600 text-danger">
            Any unauthorized access, misuse, or breach of confidentiality will be treated as a serious violation of company policy and may result in disciplinary action, termination, or legal consequences.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #connectGmailModal>
  <div class="modal-content border-0 connect-gmail-modal">
    <div class="modal-body text-center px-4 py-5">
      <div class="connect-gmail-icon mx-auto mb-3">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L4 5v6c0 5.25 3.4 9.74 8 11 4.6-1.26 8-5.75 8-11V5l-8-3z" fill="#2E7D32"/>
          <path d="M9.5 12.5l1.8 1.8 3.7-3.9" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <h4 class="fs-20 fw-700 mb-2">Connect your Google account</h4>
      <p class="fs-14 fw-400 grey-text-101 mb-4">
        Sign in with Google to verify your identity and continue using the Finance Mutual Admin Panel.
      </p>

      @if (gmailConnected) {
        <div class="fs-13 fw-500 text-success mb-3">
          Connected: {{ gmailConnectedEmail }}
        </div>
      }

      <button type="button" class="btn google-signin-btn w-100" (click)="connectGmail()" [disabled]="gmailConnecting">
        @if (gmailConnecting) {
          <span class="spinner-border spinner-border-sm text-secondary me-2" role="status">
            <span class="visually-hidden">Connecting&hellip;</span>
          </span>
        }
        @if (!gmailConnecting) {
          <svg width="18" height="18" viewBox="0 0 48 48" class="me-2">
            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/>
            <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
          </svg>
        }
        <span>{{ gmailConnecting ? 'Connecting…' : (gmailConnected ? 'Reconnect with Google' : 'Continue with Google') }}</span>
      </button>

      <p class="fs-12 grey-text-101 mt-3 mb-0">
        A Google sign-in window will open. Please allow pop-ups for this site.
      </p>
    </div>
  </div>
</ng-template>

<ng-template #unmappedContentModal>
  <div class="modal-content unmapped-content-modal border-0 shadow-lg">
    <div class="modal-header d-flex justify-content-between align-items-center p-3">
      <div class="d-flex flex-column modal-title-wrap">
        <p class="modal-kicker m-0">Communication Details</p>
        <h5 class="m-0 fs-16 fw-700">{{ selectedCommunicationItem?.lead_id ? 'Mapped Content' : 'Unmapped Content' }}</h5>
      </div>
      <button type="button" class="modal-close-btn d-inline-flex align-items-center justify-content-center border-0 p-0" (click)="modalRef.hide()" aria-label="Close content details">
        <img src="assets/images/icons/cross-icon.svg" class="hw-24" alt="Close">
      </button>
    </div>
    <div class="modal-body p-4">
      <div class="modal-meta-row d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
        <span class="modal-state-pill">{{ selectedCommunicationItem?.lead_id ? 'Mapped Lead' : 'Unmapped Thread' }}</span>
        @if (selectedCommunicationItem && getAttachments(selectedCommunicationItem).length) {
          <span class="modal-count-pill">
            {{ getAttachments(selectedCommunicationItem).length }} Attachment{{ getAttachments(selectedCommunicationItem).length > 1 ? 's' : '' }}
          </span>
        }
      </div>
      @if (salesActiveTab === 'emails' && selectedCommunicationItem?.subject) {
        <div class="modal-subject-row mb-3">
          <p class="m-0 fs-12 fw-600 text-muted text-uppercase mb-1">Subject</p>
          <h6 class="m-0 fs-15 fw-700 text-dark">{{ selectedCommunicationItem?.subject }}</h6>
        </div>
      }
      <div class="modal-content-box fs-14 fw-500" [innerHTML]="selectedCommunicationContent"></div>

      @if (selectedCommunicationItem && getAttachments(selectedCommunicationItem); as modalAttachments) {
        @if (modalAttachments.length > 0) {
          <div class="modal-attachments mt-4 pt-3 d-flex flex-wrap gap-2">
            <p class="w-100 m-0 mb-1 fs-13 fw-600">Attachments</p>
            @for (url of modalAttachments; track url; let idx = $index) {
              <a
                [href]="url"
                target="_blank"
                class="attachment-chip d-inline-flex align-items-center px-3 py-2 fs-12 fw-600 text-decoration-none cursor radius-6 transition"
                >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
                Attachment {{ modalAttachments.length > 1 ? (idx + 1) : '' }}
              </a>
            }
          </div>
        }
      }
    </div>
    <div class="modal-footer p-3 d-flex justify-content-end">
      <button type="button" class="btn btn-close-modal px-4 fs-14 fw-600 radius-6 d-inline-flex align-items-center gap-2" (click)="modalRef.hide()">
        Close
      </button>
    </div>
  </div>
</ng-template>
